export const toBlob = (
    canvas: HTMLCanvasElement,
    type: string = 'image/png',
    quality?: number
): Promise<Blob> => {
    return new Promise(resolve => {
        return canvas.toBlob(b => resolve(b!), type, quality);
    });
};